module.exports = __webpack_public_path__ + "img/9dbc6c8.svg";